export default __webpack_public_path__ + "static/media/4c.2451b59f.svg";